import React, {useEffect} from 'react';
import {
    setFilter,
    setForm,
    setItem,
    setLoading,
    setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {Card, CardBody, CardTitle} from "reactstrap";
import {LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";
import {GenericButton} from "../../../components/buttons/customButtons";
import UdnForm from "./_form";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {udnService} from "../../../jwt/_services";
import TranslateButton from "../../../components/buttons/TranslateButton";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import UdnFilters from "./_filters";

const UdnList = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    useEffect( () => {
        if (!props.generalPropouse) {
            if( !app.id || filter)
                return

            props.setFilter(path , {
                fbDataBase: {id: app?.fbDataBase?.id},
                onlyRegistered: true
            });
        } else {
            const _filter = {
                onlyRegistered : false,
                item : {
                }
            };

            props.setFilter(path, _filter);
        }
    }, [ app ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, udnService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path, tableChangeParams.sizePerPage, currentIndex, totalSize, currentIndex );
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( UdnForm, { path, generalPropouse : props.generalPropouse } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(UdnForm, { path, data, Form: UdnForm, generalPropouse : props.generalPropouse })
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({
            remove : genericIndexedActions.delete ,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: udnService,
            path
        } );
    };

    const handleStatusChange = async (id, data, _status) => {
        genericIndexedActions.update(path, udnService, id, {
            fbDataBase: {id: app?.fbDataBase?.id},
            item: {...data, status: _status, id: id}
        })
    }

    const notImplemented = () => {
        console.log('Not implemented')
    }

    const actionsFormatter = (cell, row) => <div key={`action-${row?.id}`}>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={udnService} path={path}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </div>

    const columns = [{
        dataField: 'id',
        text: 'ID',
        headerStyle: {width: '0px'},
        hidden: true
    }, {
        dataField: 'uid',
        text: 'UID',
        headerStyle: {width: '200px'},
        hidden: props.generalPropouse
    }, {
        dataField: 'code',
        text: 'Código',
        headerStyle: {width: '100px'},
    },{
        dataField: 'productName',
        text: 'Nombre',
        formatter: (cell,row)=><>{row?.productName}</>
    },{
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '80px'},
        formatter: (cell, row) => <GenericSwitch
            id={ row?.id }
            initialState={ row?.status }
            onChange={ handleStatusChange }
        />
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '280px'},
        formatter: actionsFormatter
    }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <UdnFilters path={path} generalPropouse={props.generalPropouse}/>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(UdnList)